import { mdiRefresh, mdiRestore, mdiContentCopy, mdiClose, mdiArrowTopRight } from "@mdi/js";
import Icon from "@mdi/react";
import { debounce } from "lodash";
import moment from "moment";
import { FunctionComponent, useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import LoadingWidget from "../../../context_providers/modal/loader";
import {
  useModal,
  ModalType,
  ModalAlignment,
} from "../../../context_providers/modal/modal_context";
import {
  useToast,
  ToastType,
} from "../../../context_providers/toast/toast_ctx";
import { FieldType } from "../../../procurement/components/create_view/form_field";
import {
  fetchDelete,
  fetchGet,
  fetchPost,
  toQueryString,
} from "../../../service/api_client";
import SearchFieldWidget from "../../../ui/new_components/search_field";
import { UTCToLocalDate } from "../../../utils/date_util";
import { currencyFormat } from "../../../utils/currency_format";
import { urls } from "../../../utils/urls";
import {
  AttachmentModel,
  PurchaseOrderModel,
  getFileType,
  po_approval_status,
} from "../model/purchase_order_model";
import NewTableView, {
  NewTableRow,
} from "../../../procurement/components/new_table_comp";
import { ACTION, file_dir, MODULE } from "../../../utils/enums";
import axios from "axios";
import DrawerWidget from "../../../context_providers/modal/drawer_widget";
import {
  PartyModel,
  defaulPartyValue,
} from "../../accounts/models/party_model";
import DrawerModal, {
  DrawerModalLoaction,
} from "../../../ui/new_components/common/drawer_modal";
import ModalDialog from "../../../ui/new_components/common/modal";
import { getPurchaseOrderListDataRepo } from "../purchase_order_create/service/po_service";
import AttachmentSection from "../purchase_order_create/components/attachmnet";
import ExportPreviousPO from "../purchase_order_create/components/Previous_PO_Export";
import { useAuth } from "../../../context_providers/auth/authProvider";

export interface POListFilter {
  page: number;
  count: number;
  all: boolean | null;
  search?: string;
  fromDate?: Date;
  toDate?: Date;
  party_id?: string;
  party_name?: string;
  approval_status?: string;
}

const defaultFilter = (): POListFilter => {
  const now = new Date();
  // const { start_date, end_date } = GetStartAndEndDateOfMonth(now);
  // const start_date = new Date(new Date(now).setDate(now.getDate() - 30));
  // const end_date = now;
  return {
    page: 1,
    count: 100,
    all: false,
    // fromDate: start_date,
    // toDate: end_date,
  };
};
interface PurchaseOrderListScreenProps {
  location?: any;
}

const PurchaseOrderListScreen: FunctionComponent<
  PurchaseOrderListScreenProps
> = (props) => {
  const query = new URLSearchParams(props.location.search);
  const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/prev-purchase-order`;
  const { showModal, onClose } = useModal();
  const [showExport, setShowExport] = useState(false);
  const [ShowHistory, setShowHistory] = useState<any>();
  const [ShowHistory1, setShowHistory1] = useState<any>();
  const tempFilter = localStorage.getItem("po_list_filter");

  const [filter, setFilter] = useState<POListFilter>(
    tempFilter ? JSON.parse(tempFilter) : defaultFilter(),
  );
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);

  const [total, setTotal] = useState(0);
  const [data, setData] = useState<PurchaseOrderModel[]>([]);
  const { isAuthorised } = useAuth();
  const navigation = useHistory();

  const fetchData = async (prop: POListFilter) => {
    console.log(prop);
    setLoading(true);
    try {
      const res = await getPurchaseOrderListDataRepo(prop);
      if (res.success) {
        setData(res.data.data);
        if (res.data.metadata) {
          setTotal(res.data.metadata.total);
        }
      } else {
        showToast({ type: ToastType.error, text: res.error });
      }
    } catch (error: any) {
      showToast({ type: ToastType.error, text: error.message });
      //   return { success: false, error: error.message };
    }
    setLoading(false);
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedHandler = useCallback(
    debounce((prop: POListFilter) => {
      if (prop) fetchData(prop);
      else setData([]);
    }, 100),
    [],
  );

  // useEffect(() => {
  //   fetchData({ page, count, search });
  // }, [page]);
  const navaigation = useHistory();
  // const onSelect = (d: PurchaseOrderModel) => {
  //   navaigation.push(urls.purchase_order + "/update/" + d.id);
  // };
  // const onDelete = async (d: PurchaseOrderModel) => {
  //   const propmt = window.prompt("Type 'delete' to confirm.");
  //   if (!propmt || propmt?.trim() !== "delete") {
  //     return;
  //   }
  //   setLoading(true);
  //   const res = await fetchDelete(url + "/" + d.id);
  //   if (res.success) {
  //     await fetchData(filter);
  //     showToast({ type: ToastType.success, text: res.message });
  //   } else {
  //     showToast({ type: ToastType.error, text: res.error });
  //   }
  //   setLoading(false);
  // };

  useEffect(() => {
    if (tempFilter) {
      const t: POListFilter = JSON.parse(tempFilter);
      if (t.party_id) {
        const v = defaulPartyValue;
        v.id = t.party_id;
        v.name = t.party_name ?? "";
        console.log({ v });
        setVendor(v);
      }
    }
    localStorage.setItem("po_list_filter", JSON.stringify(filter));
    debouncedHandler(filter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);
  const [vendor, setVendor] = useState<PartyModel>();
  const [showAttachment, setShowAttachment] = useState<PurchaseOrderModel>();
  const [attachmentKey, setAttachmentKey] = useState(Math.random() * 10000);

  const uploadFile = async ({
    file,
    category,
    removeSelectedFile,
    setShowUpload,
  }: {
    file: File;
    category: string;
    removeSelectedFile: () => void;
    setShowUpload: (v: boolean) => void;
  }) => {
    try {
      if (!file || !category) {
        showToast({
          type: ToastType.warning,
          text: "Please select file and category",
        });
        return;
      }
      setLoading(true);
      const { name, type } = file;
      const create_url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/prev-purchase-order/${showAttachment?.id}/attachment`;
      const get_signed_urls = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/signed-url`;
      const query = {
        mimetype: type,
        extension: name.split(".").pop(),
        dir: file_dir.pocuremnt_attachments,
      };
      const res = await fetchGet(get_signed_urls + toQueryString(query));
      if (res.success) {
        const { signed_url, url } = res.data;

        //   const options = {
        //     method: "PUT",
        //     body: file,
        //     headers: {
        //       "Content-Type": type,
        //     },
        //   };
        const aws_res = await axios.put(signed_url, file, {
          headers: {
            "Content-Type": type,
          },
        });

        const attachment: AttachmentModel = {
          id: "",
          category,
          type: getFileType(type),
          url,
        };
        const create_res = await fetchPost(create_url, attachment);
        console.log({ create_res });
        if (create_res.success) {
          showToast({
            type: ToastType.success,
            text: create_res.message,
          });
          setData((o) => [
            ...o.map((f) => {
              if (f.id === showAttachment)
                return {
                  ...f,
                  attachments: [...(f.attachments || []), create_res.data],
                };
              return f;
            }),
          ]);

          removeSelectedFile();
          setShowUpload(false);
          setAttachmentKey(Math.random() * 1000);
        }
      }
      setLoading(false);
    } catch (error: any) {
      showToast({
        type: ToastType.error,
        text: error.message,
      });
      setLoading(false);
    }
  };
  const deleteFile = async (att: AttachmentModel) => {
    try {
      if (!window.confirm("Are your sure to delete ?")) return;
      if (!att) {
        showToast({
          type: ToastType.warning,
          text: "Please select file",
        });
        return;
      }
      setLoading(true);
      const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/prev-purchase-order/${showAttachment?.id}/attachment/${att.id}`;

      const res = await fetchDelete(url);

      if (res.success) {
        showToast({
          type: ToastType.success,
          text: res.message,
        });
        setData((o) => [
          ...o.map((f) => {
            if (f.id === showAttachment) {
              f.attachments = f.attachments.filter((f) => f.id !== att.id);
            }
            return f;
          }),
        ]);

        setAttachmentKey(Math.random() * 1000);
      }
      setLoading(false);
    } catch (error: any) {
      showToast({
        type: ToastType.error,
        text: error.message,
      });
      setLoading(false);
    }
  };

  const onSelectAttchment = (d: AttachmentModel) => {
    window.open(d.url, "_blank");
  };

  useEffect(() => {
    const warehouse_operator_permission = isAuthorised({
      module: MODULE.warehouse_operator,
      action: ACTION.READ,
    });

    if (warehouse_operator_permission) {
      navigation.replace(urls.notAllowed);
    }
  }, []);

  return (
    <>
      {showExport && (
        <ModalDialog
          show={showExport}
          title="Export"
          onClose={() => setShowExport(false)}
        >
          <ExportPreviousPO filter={filter} />
        </ModalDialog>
      )}
      {ShowHistory && (
        <DrawerModal
          location={DrawerModalLoaction.right}
          show={ShowHistory !== undefined}
          onClose={() => setShowHistory(undefined)}
          title="History"
        >
          {/* {console.log("id of order", ShowHistory)} */}
          {/* <ActionHistory
              po_no={ShowHistory}
              data={ShowHistory1}
              // show={ShowHistory !== undefined}
              // onClose={(v) => setShowHistory(undefined)}
            /> */}
        </DrawerModal>
      )}
      {showAttachment && (
        <DrawerWidget
          data={{
            id: 1,
            title: "Attchments",
            type: ModalType.drawer,
            alignment: ModalAlignment.right,
            container: (
              <AttachmentSection
                key={attachmentKey}
                poNo={showAttachment}
                attachments={showAttachment.attachments}
                onSubmit={uploadFile}
                onDelete={deleteFile}
                onSelect={onSelectAttchment}
              />
            ),
          }}
          onClose={function (): void {
            setShowAttachment(undefined);
          }}
        ></DrawerWidget>
      )}
      <div
        id="page_container"
        className="flex flex-col justify-between h-full p-1"
      >
        <section id="top_section" className=" ">
          <div className="flex justify-between items-end my-1 flex-wrap">
            <h1 className="font-bold text-2xl text-gray-500 flex items-center gap-3">
              <p className=" font-bold border-l-4 border-myPrimaryColor pl-2">
                Purchase orders
              </p>
              <button title="Refersh" onClick={() => debouncedHandler(filter)}>
                <Icon path={mdiRefresh} className="h-6 w-6"></Icon>
              </button>
            </h1>
            <div className="flex justify-end   text-sm items-center gap-1 ">
              <SearchFieldWidget
                defaulValue={filter.search}
                onClear={() => {
                  setFilter((o) => ({ ...o, search: "", page: 1 }));
                }}
                onSubmit={(val) => {
                  setFilter((o) => ({
                    ...o,
                    search: val,
                    page: 1,
                  }));

                  // setTimeout(() => {
                  //   setSearch(val);
                  // }, 10);
                }}
              />
              <button
                onClick={() => {
                  console.log("export");
                  setShowExport(true);
                }}
                className="rounded-lg border px-2 py-1 hover:bg-gray-800 hover:text-white flex gap-2 items-center"
              >
                <Icon path={mdiArrowTopRight} className="h-4 w-4"></Icon>Export
                PO
              </button>
              {/* <button
                  onClick={() => {
                    navaigation.push(urls.purchase_order_prev + "/create");
                  }}
                  className="flex gap-1 items-center cursor-pointer rounded p-1 bg-myPrimaryColor hover:scale-105 duration-200  text-white  transform"
                >
                  <Icon path={mdiPlus} className="h-4 w-4"></Icon>Add PO
                </button> */}
            </div>
          </div>
          <div className="py-2">
            <div className="text-sm flex items-center gap-2">
              <div className="flex items-center  gap-1">
                <label htmlFor="fromDate" className="">
                  From
                </label>
                <input
                  type="date"
                  name=""
                  id="fromDate"
                  className="p-1 rounded focus:outline-none"
                  value={
                    filter.fromDate
                      ? moment(filter.fromDate).format("YYYY-MM-DD")
                      : ""
                  }
                  onChange={(e) => {
                    const now = UTCToLocalDate(e.target.value)!;
                    const fromDate = new Date(
                      new Date(now).setHours(0, 0, 0, 0),
                    );
                    setFilter((o) => ({ ...o, fromDate }));
                  }}
                />
              </div>
              <div className="flex items-center  gap-1">
                <label htmlFor="toDate" className="">
                  To
                </label>
                <input
                  type="date"
                  name=""
                  id="toDate"
                  className="p-1 rounded focus:outline-none "
                  value={
                    filter.toDate
                      ? moment(filter.toDate).format("YYYY-MM-DD")
                      : ""
                  }
                  onChange={(e) => {
                    const now = UTCToLocalDate(e.target.value)!;
                    const toDate = new Date(
                      new Date(now).setHours(23, 59, 59, 999),
                    );
                    setFilter((o) => ({ ...o, toDate }));
                  }}
                />
              </div>
              {(filter.fromDate || filter.toDate) && (
                <button
                  title="Clear dates"
                  onClick={() =>
                    setFilter((o) => ({
                      ...o,
                      fromDate: undefined,
                      toDate: undefined,
                    }))
                  }
                  className="flex gap-1 items-center cursor-pointer rounded p-1 border  r hover:scale-105 duration-200     transform"
                >
                  <Icon path={mdiClose} size={0.7}></Icon>
                </button>
              )}
              <div className="flex items-center  gap-1">
                <label htmlFor="app_status" className="">
                  Approval status
                </label>
                <select
                  className="p-1 rounded focus:outline-none"
                  name=""
                  id="app_status"
                  value={filter.approval_status}
                  onChange={(e) => {
                    setFilter((o) => ({
                      ...o,
                      approval_status: e.target.value,
                    }));
                  }}
                >
                  <option value="" hidden>
                    select
                  </option>
                  {Object.values(po_approval_status).map((f) => (
                    <option key={f} value={f}>
                      {f}
                    </option>
                  ))}
                </select>
                {filter.approval_status && (
                  <button
                    title="Clear approval status"
                    onClick={() =>
                      setFilter((o) => ({
                        ...o,
                        approval_status: "",
                      }))
                    }
                    className="flex gap-1 items-center cursor-pointer rounded p-1 border  r hover:scale-105 duration-200     transform"
                  >
                    <Icon path={mdiClose} size={0.7}></Icon>
                  </button>
                )}
              </div>
              <div className="flex items-center  gap-1">
                <label htmlFor="" className="">
                  Vendor
                </label>
                <SearchFieldWidget
                  defaulValue={filter?.party_name}
                  onClear={() => {
                    setFilter({
                      ...filter,
                      party_name: undefined, // Fixed indentation
                    });
                    // setPage(1);
                  }}
                  onSubmit={(val) => {
                    setFilter({
                      ...filter,
                      party_name: val, // Fixed indentation
                    });
                    // setPage(1);
                  }}
                />
                <div className="w-96 flex ">
                  {/* <PartySearchField
                      // show_add={false}
                      placeholder="Select vendor"
                      onSelect={(d) => {
                        setFilter((o) => ({
                          ...o,
                          party_id: d?.id ?? undefined,
                          party_name: d?.name ?? undefined,
                        }));
                        setVendor(d);
                      }}
                      value={vendor}
                    />
                    {filter.party_id && (
                      <button
                        title="Clear vendor"
                        onClick={() =>
                          setFilter((o) => ({ ...o, party_id: undefined }))
                        }
                        className="flex gap-1 items-center cursor-pointer rounded p-1 border  r hover:scale-105 duration-200     transform bg-white"
                      >
                        <Icon path={mdiClose} size={0.7}></Icon>
                      </button>
                    )} */}
                  <button
                    title="Reset filters"
                    onClick={() => setFilter(defaultFilter())}
                    className="flex gap-1 items-center cursor-pointer rounded p-1 border  r hover:scale-105 duration-200     transform bg-white"
                  >
                    <Icon path={mdiRestore} size={0.7}></Icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="h-52 w-full bg-green-200 "></div> */}
        </section>

        <NewTableView
          stickyHeader={true}
          show_index={true}
          show_pagination={true}
          headers={[
            {
              key: "po_no",
              value: "PO #",
              type: FieldType.string,
            },
            {
              key: "project_name",
              value: "Project",
              type: FieldType.string,
            },
            {
              key: "date",
              value: "Date",
              type: FieldType.date,
            },
            {
              key: "delivery_date",
              value: "Delivery date",
              type: FieldType.date,
            },
            {
              key: "item",
              value: "Item",
              type: FieldType.string,
            },
            {
              key: "party",
              value: "Party",
              type: FieldType.string,
            },
            {
              key: "",
              value: "Responsible",
              type: FieldType.string,
            },
            {
              key: "warehouse",
              value: "Warehouse",
              type: FieldType.string,
            },

            {
              key: "approval_status",
              value: "Approval status",
              type: FieldType.string,
            },

            {
              key: "status",
              value: "Status",
              type: FieldType.string,
            },
            {
              key: "total",
              value: "Total",
              type: FieldType.currency,
            },
            {
              key: "paid",
              value: "Paid",
              type: FieldType.currency,
            },
            {
              key: "balance",
              value: "Balance",
              type: FieldType.currency,
            },
            {
              key: "",
              value: "Attachment",
              type: FieldType.string,
            },
          ]}
          rows={data.map((data, i) => {
            const row: NewTableRow<PurchaseOrderModel> = {
              data: data,

              cells: [
                {
                  value: data.po_no,
                  builder: () => (
                    <div className="flex items-center justify-start gap-1 p-1 h-full sticky-field whitespace-nowrap">
                      <button
                        onClick={() => {
                          navigator.clipboard.writeText(data.po_no);
                          showToast({
                            type: ToastType.info,
                            text: "Copied PO NO to clip board!",
                          });
                        }}
                      >
                        <Icon path={mdiContentCopy} size={0.5}></Icon>
                      </button>
                      #{data.po_no}
                    </div>
                  ),
                },
                { value: data.project },
                { value: data.created_at },
                { value: data.delivery_date },
                {
                  maxLines: 2,
                  builder: () => (
                    <a
                      href={urls.purchase_order_prev + "/update/" + data.id}
                      className="px-2 text-left text-blue-400 hover:text-blue-500  h-full w-full whitespace-pre  "
                    >
                      {`${data?.items[0]?.item.name} ${
                        data.items?.length > 1
                          ? `... and ${data.items.length - 1} more`
                          : ""
                      }`}
                    </a>
                  ),
                  title: `${data.items.reduce(
                    (p, v) => p + v.item.name + " | ",
                    "",
                  )}  `,
                },
                { value: data.party.name, align: "left" },
                { value: data.shipping_profile.contact_name },
                { value: data.warehouse.name },
                {
                  value:
                    data.approval_level === data.current_approval_level &&
                    (data.current_approval_count ?? 0) >=
                      (data.current_approval_required_count ?? 0)
                      ? "Approved"
                      : (data.current_approval_required_count ?? 0) > 0 &&
                          (data.current_reject_count ?? 0) -
                            (data.current_approval_count ?? 0) >=
                            (data.current_approval_required_count ?? 0)
                        ? "Rejected"
                        : "Pending",
                },
                { value: data.status },
                {
                  align: "right",
                  value: currencyFormat(
                    data.total,
                    data?.vendor_currency?.short_name,
                  ),
                },
                { value: data?.paid },
                { value: data?.total - data?.paid },
                {
                  builder: () => (
                    <button
                      onClick={() => setShowAttachment(data)}
                      className="relative text-sm font-semibold text-blue-400 hover:text-blue-500 whitespace-nowrap sticky-field  flex items-center gap-1 px-2 h-full w-full"
                    >
                      View
                      <div>({data?.attachments?.length}+)</div>
                    </button>
                  ),
                },
              ],
            };
            return row;
          })}
          onShowHistory={(data) => {
            setShowHistory(data.po_no);
            setShowHistory1(data);
          }}
          page={filter.page}
          total={total}
          count={filter.count}
          itemCount={data.length}
          onPageChange={(page) => {
            setFilter((o) => ({ ...o, page }));
          }}
        />

        {/* <TableView
            headers={[
              {
                key: "po_no",
                title: "PO #",
                type: FieldType.string,
              },
              {
                key: "date",
                title: "Date",
                type: FieldType.date,
              },
              {
                key: "delivery_date",
                title: "Delivery date",
                type: FieldType.date,
              },
              {
                key: "item",
                title: "Item",
                type: FieldType.string,
              },
              {
                key: "party",
                title: "Party",
                type: FieldType.string,
              },
              {
                key: "",
                title: "Responsible",
                type: FieldType.string,
              },
              {
                key: "warehouse",
                title: "Warehouse",
                type: FieldType.string,
              },
  
              {
                key: "approval_status",
                title: "Approval status",
                type: FieldType.string,
              },
  
              {
                key: "status",
                title: "Status",
                type: FieldType.string,
              },
              {
                key: "total",
                title: "Total",
                type: FieldType.currency,
              },
            ]}
            rows={data.map((data, i) => {
              return {
                data,
                values: [
                  data.po_no,
                  data.date,
                  data.delivery_date,
                  `${data.items[0].item.name} ${
                    data.items.length > 1
                      ? `... and   ${data.items.length - 1} more`
                      : ""
                  }`,
                  data.party.name,
                  data.shipping_profile.contact_name,
                  data.warehouse.name,
                  data.approval_level == data.current_approval_level &&
                  (data.current_approval_count ?? 0) >=
                    (data.current_approval_required_count ?? 0)
                    ? "Approved"
                    : (data.current_approval_required_count ?? 0) > 0 &&
                      (data.current_reject_count ?? 0) -
                        (data.current_approval_count ?? 0) >=
                        (data.current_approval_required_count ?? 0)
                    ? "Rejected"
                    : "Pending",
                  data.status,
                  currencyFormat(data.total, data?.vendor_currency?.short_name),
                ],
              };
            })}
            page={filter.page}
            total={total}
            count={filter.count}
            itemCount={data.length}
            onPageChange={(page) => {
              setFilter((o) => ({ ...o, page }));
            }}
            // onClick={onSelect}
            onEdit={onSelect}
            onDelete={onDelete}
          /> */}
      </div>

      {loading && <LoadingWidget></LoadingWidget>}
    </>
  );
};

export default PurchaseOrderListScreen;
